module.exports = __webpack_public_path__ + "static/media/SILKSERIF-SEMIBOLD.044fea3e.woff2";